import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

import { reactive, ref, PropType, onMounted, computed, watch } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import CmTable from '@/components/cmTable/index.vue'
import { listCol } from '@/utils/list-columns-i18n'
import ExportDropdown from '@/views/dashboard/_components/export-dropdown/export-dropdown.vue'

import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import BtnIcon from '@/views/dashboard/_components/btn-icon/btn-icon.vue'
import TerminalIconName from '@/views/dashboard/_components/terminal-icon-name/terminal-icon-name.vue'
import IPColumn from '@/views/dashboard/_components/ip-column/IPColumn.vue'
import GroupTreeSelector from '@/views/dashboard/_components/group-tree-selector/group-tree-selector.vue'
import {
  ClientViewService,
  ClientInfo,
  QueryParams as ClientQueryParams,
} from '../client-view/client-view.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  FormSize,
  FormType,
  ObjectFormItem,
} from '@/components/cmForm/types'
import { TableOpt, TableActOpt } from '@/components/cmTable/types'
import { TableViewMode, TableViewModeType } from '@/views/dashboard/_enum/table-view-mode'
import { ServicePermissionService, PermissionFe } from '@/services/service-permission.service'
import { TerminalType } from '@/views/dashboard/_enum/terminal-type'


export default /*#__PURE__*/_defineComponent({
  __name: 'terminal-list-top10',
  props: {
  viewMode: {
    type: String as PropType<TableViewModeType>,
    default: TableViewMode.preview
  },
  hasPermission: {
    type: Boolean,
    default: true
  },
  groupId: {
    type: Number,
    default: -1
  }
},
  emits: ['viewAll', 'detail'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t, locale } = useI18n()
const props = __props

const emits = __emit

const injector = useReflectiveInjector()
const clientService = injector.get(ClientViewService)
const servicePermissionService = injector.get(ServicePermissionService)
const dataApi = clientService.getSoftmgrTerminalStat.bind(clientService)
const hasPermission = props.hasPermission || servicePermissionService.getHasPermission(PermissionFe.softmgr)

const tableRef = ref()
const { refreshList } = useCmTableListRefresh(tableRef)
const total = computed(() => tableRef.value?.total || 0)

const queryParams = reactive<ClientQueryParams>({
  key_word: '',
  group_id: props.groupId,
  page: 1,
  limit: props.viewMode === TableViewMode.preview ? 10 : 20,
  sort: 'soft_count',
  asc: false
})

/** 与列表 group_id 对齐，避免分组树加载完成后 emit 的默认节点覆盖父级传入的部门 id */
const groupTreeDefaultId = computed(() =>
  props.groupId != null && props.groupId !== -1 ? props.groupId : null
)

const filterFormColumns = computed<ObjectFormItem<ClientQueryParams, 'group_id'>>(() => {
  void locale.value
  return {
    group_id: {
      colOpt: { style:'flex:0 0 150px' },
      slot: true,
      label: t('softwareManage.filterGroup'),
      outSearchFiledFlag: true,
      hiddenAllLabel: true,
      events: {
        change: handleQuery,
      },
    },
  }
})

const tableActOpt = computed<TableActOpt>(() => {
  void locale.value
  return {
    columnOpt: { label: listCol(t, 'operation'), width: 100, fixed: 'right' },
    actionButtons: () => [
      { name: listCol(t, 'detail'), type: 'detail', opt: { size: FormSize.Small, text: true, type: 'text' } }
    ]
  }
})

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    bodyStyle: props.viewMode === TableViewMode.full ? 'padding: 10px 16px' : undefined,
    path: 'list',
    height: props.viewMode === TableViewMode.preview ? undefined : '100%',
    showActionBar: false,
    showForm: false,
    showRightToolbar: false,
    rowKey: 'device_id',
    selection: false,
    showTip: false,
    usePagination: false,
    disableScrollLoad: props.viewMode === TableViewMode.preview,
    scrollLoadThreshold: 10,
    scrollLoadDelay: 100,
    columns: [
      { prop: 'computer_name',type:"COMPUTER", label: listCol(t, 'computerName'), columnOpt: { minWidth: 160 } },
      { prop: 'group_name', label: listCol(t, 'groupName'), columnOpt: { minWidth: 120 } },
      { prop: 'user_mark', label: listCol(t, 'userMark'), columnOpt: { minWidth: 120 } },
      { prop: 'ip_address',type:"IP", label: listCol(t, 'ipAddress'), columnOpt: { minWidth: 200 } },
      { prop: 'soft_count', label: t('softwareManage.softwareCount'), columnOpt: { minWidth: 100 }, sortable: 'custom' }
    ],
    totalPath: 'total',
    tableActOpt: tableActOpt.value
  }
})

watch(() => props.groupId, (v) => {
  if (queryParams.group_id === v) return
  queryParams.group_id = v
  queryParams.page = 1
  void refreshList()
})

async function updateGroupId(groupId: number) {
  if (queryParams.group_id === groupId) return
  queryParams.group_id = groupId
  queryParams.page = 1
  await refreshList()
}

async function handleSearch(value: string) {
  queryParams.key_word = value
  queryParams.page = 1
  await refreshList()
}

async function handleQuery(form: any) {
  Object.assign(queryParams, form)
  queryParams.page = 1
  await refreshList()
}

function handleReset() {
  queryParams.key_word = ''
  queryParams.group_id = props.groupId
  queryParams.page = 1
  void refreshList()
}

function handleAction({ type, rowItem }: { type: string; rowItem: ClientInfo }) {
  if (type === 'detail') {
    handleDetail(rowItem)
  }
}

function handleDetail(item: ClientInfo) {
  emits('detail', item)
}

function download(type: 0 | 1) {
  clientService.download(type, queryParams, t('softwareManage.exportTerminalView'))
}

onMounted(async () => {
  if (!hasPermission) return
  await refreshList()
})

__expose({
  tableRef,
  getList: () => void refreshList(),
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(CmTable, {
    ref_key: "tableRef",
    ref: tableRef,
    tableOpt: tableOpt.value,
    tableActOpt: tableActOpt.value,
    firstLoading: false,
    "has-permission": _unref(hasPermission),
    api: _unref(dataApi),
    modelValue: queryParams,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryParams) = $event)),
    pageOption: {
      style: 'padding-bottom: 16px',
      pageNumName: 'page',
      pageSizeName: 'limit',
    },
    onHandleAction: handleAction
  }, {
    header: _withCtx(() => [
      _createVNode(SearchFilterBar, {
        modelValue: queryParams,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams) = $event)),
        "form-columns": filterFormColumns.value,
        disabled: !_unref(hasPermission),
        "show-search": true,
        "search-placeholder": _ctx.$t('softwareManage.searchPlaceholderTerminal'),
        "popover-threshold": 0,
        onSearch: handleSearch,
        onQuery: handleQuery,
        onReset: handleReset
      }, {
        group_id: _withCtx(() => [
          _createVNode(GroupTreeSelector, {
            width: "100%",
            disabled: !_unref(hasPermission),
            "terminal-type": [_unref(TerminalType).windows, _unref(TerminalType).windowsServer],
            "default-group-id": groupTreeDefaultId.value,
            onSelected: updateGroupId
          }, null, 8, ["disabled", "terminal-type", "default-group-id"])
        ]),
        actions: _withCtx(() => [
          _createVNode(ExportDropdown, {
            "has-permission": _unref(hasPermission),
            onExport: download
          }, null, 8, ["has-permission"]),
          (props.viewMode === _unref(TableViewMode).preview)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                size: "small",
                disabled: !_unref(hasPermission),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('viewAll')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('commonPage.viewAll')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "form-columns", "disabled", "search-placeholder"])
    ]),
    soft_count: _withCtx(({ row }: { row?: ClientInfo }) => [
      row
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            size: "small",
            disabled: !row.soft_count,
            type: "text",
            onClick: ($event: any) => (handleDetail(row))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(row.soft_count), 1)
            ]),
            _: 2
          }, 1032, ["disabled", "onClick"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_1, "0"))
    ]),
    _: 1
  }, 8, ["tableOpt", "tableActOpt", "has-permission", "api", "modelValue"]))
}
}

})